// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/media-document/sentiment/sentiment.scss
// module id = 162
// module chunks = 0